// client/src/pages/admin/ManagePages.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function ManagePages() {
  const token = localStorage.getItem('authToken');
  const [pages, setPages] = useState([]);

  // form fields
  const [pageId, setPageId] = useState(null);
  const [slug, setSlug] = useState('');
  const [content, setContent] = useState('');

  const fetchPages = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/pages`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPages(data);
    } catch (err) {
      console.error('Error fetching pages:', err);
    }
  };

  useEffect(() => {
    fetchPages();
    // eslint-disable-next-line
  }, []);

  const resetForm = () => {
    setPageId(null);
    setSlug('');
    setContent('');
  };

  const handleSubmit = async () => {
    try {
      // Force the slug to lowercase (trim whitespace)
      const finalSlug = slug.trim().toLowerCase();

      if (!pageId) {
        // Create new page
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/pages`,
          { slug: finalSlug, content },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Page created successfully!');
      } else {
        // Update existing page
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/pages/${pageId}`,
          { slug: finalSlug, content },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Page updated successfully!');
      }

      resetForm();
      fetchPages();
    } catch (err) {
      console.error('Error creating/updating page:', err);
      alert('Failed to submit page');
    }
  };

  const handleEdit = (page) => {
    setPageId(page._id);
    setSlug(page.slug);       // Show the actual stored slug (could be uppercase)
    setContent(page.content);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this page?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/pages/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Page deleted');
      fetchPages();
    } catch (err) {
      console.error('Error deleting page:', err);
      alert('Error deleting page');
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Manage Pages</h1>

      {/* CREATE/EDIT FORM */}
      <div className="mb-6">
        <label className="block mb-1 font-medium">Slug</label>
        <input
          type="text"
          className="border p-2 w-full max-w-sm"
          value={slug}
          onChange={e => setSlug(e.target.value)}
        />

        <label className="block mb-1 font-medium mt-4">Content</label>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          style={{ minHeight: '200px' }}
        />

        <div className="mt-4">
          <button
            onClick={handleSubmit}
            className="bg-primaryGreen text-white px-4 py-2 rounded hover:bg-green-500"
          >
            {pageId ? 'Update Page' : 'Add Page'}
          </button>
          {pageId && (
            <button
              onClick={resetForm}
              className="ml-2 bg-gray-300 text-black px-3 py-2 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
          )}
        </div>
      </div>

      <hr className="my-6" />

      {/* LIST PAGES */}
      <h2 className="text-xl font-bold mb-4">Existing Pages</h2>
      <div className="space-y-4">
        {pages.map(pg => (
          <div key={pg._id} className="border p-3 rounded flex justify-between items-start">
            <div>
              <h3 className="font-semibold text-lg mb-1">
                {pg.slug.toUpperCase()}
              </h3>
              {/* Show small snippet of content */}
              <div
                className="text-sm text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: pg.content
                    ? pg.content.substring(0, 100) + (pg.content.length > 100 ? '...' : '')
                    : ''
                }}
              />
            </div>
            <div className="space-x-2">
              <button
                onClick={() => handleEdit(pg)}
                className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(pg._id)}
                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
